import * as React from "react";
import PhoneInput, { type Value } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { cn } from "@/lib/utils";

/**
 * A styled wrapper around react-phone-number-input that matches Shadcn UI styles.
 * Features automatic country searching natively when typing in the dropdown.
 */
export interface PhoneInputProps {
    value: string;
    onChange: (value: string | undefined) => void;
    id?: string;
    placeholder?: string;
    disabled?: boolean;
    className?: string;
    defaultCountry?: any;
}

export function PhoneInputField({
    value,
    onChange,
    id,
    placeholder = "Enter phone number",
    disabled = false,
    className,
    defaultCountry = "US",
}: PhoneInputProps) {
    return (
        <div 
            className={cn(
                "flex items-center rounded-md border border-input bg-transparent text-sm shadow-sm transition-colors focus-within:ring-1 focus-within:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                className
            )}
        >
            <PhoneInput
                id={id}
                placeholder={placeholder}
                value={(value as Value) || undefined}
                onChange={onChange}
                disabled={disabled}
                defaultCountry={defaultCountry}
                international
                countryCallingCodeEditable={false}
                // We inject custom classes directly into the sub-elements to override the default library styling
                className="w-full flex"
                numberInputProps={{
                    className: "flex h-9 w-full rounded-r-md border-0 bg-transparent px-3 py-1 text-sm shadow-none transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus:outline-none disabled:cursor-not-allowed disabled:opacity-50",
                }}
            />
        </div>
    );
}

// Global CSS overrides required to make the dropdown match the theme
export const customPhoneStyles = `
.PhoneInput {
    align-items: stretch !important;
}
.PhoneInputCountry {
    padding: 0 0.75rem;
    border-right: 1px solid hsl(var(--border));
    margin-right: 0 !important;
}
.PhoneInputCountrySelect {
    cursor: pointer;
}
.PhoneInputCountryIcon {
    width: 1.5em;
    height: 1.1em;
    border: none;
    box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
}
`;
